module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"cs":{"HeaderMainHook":{"freeShipping":"Doprava zdarma nad {price}"}},"en":{"HeaderMainHook":{"freeShipping":"Free shipping over {price}"}}}')
  delete Component.options._Ctor
}
